import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

interface product {
  name: string;
  productId: number;
}

@Component({
  selector: 'app-modify-customer-product-price',
  templateUrl: './modify-customer-product-price.component.html',
  styleUrls: ['./modify-customer-product-price.component.css']
})
export class ModifyCustomerProductPriceComponent implements OnInit {

  customerProductPriceList:any = [];
  singleCustomerProductPriceList:any = [];

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  isEdit: boolean = false

  editCustomerProductPriceForm: any | FormGroup;
  cid: any;
  formSubmit: boolean = false;

  productList: any = []
  products: product[] | any = [];
  selectedProduct: any;

  customerList: any = []
  customers: any = [];
  selectedCustomers: any;

  uomList: any = []
  uoms: any = [];
  selectedUOM: any;

  constructor(
    private generic_service: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);


    this.cid = sessionStorage.getItem('cid')
    this.editCustomerProductPriceForm = this.fb.group({
      description: [''],
      customerId: [''],
      productId: [''],
      uom: [''],
      minQty: [''],
      maxQty: [''],
      perUnitPrice: [''],
      customerName: [''],
      productName: ['']
    })
    this.getAllProducts()
    this.getAllCustomerWithoutPagination()
    this.getAllUomMaster()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event - 1;
    this.pageNumber1 = event;
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
  }

  getAllCustomerProductPrice(pageNumber: any,recordsPerPage: any){
    this.generic_service.getAllCustomerProductPrice(pageNumber,recordsPerPage).subscribe(
      (response:any)=> {
        console.log(response)
        this.customerProductPriceList = response.response.customerProductPriceList;
        this.totalRecords = response.response.totalRecords
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getCustomerProductPriceByCustomerProductPriceId(customerProductPriceId: any){
    this.generic_service.getCustomerProductPriceByCustomerProductPriceId(customerProductPriceId).subscribe(
      (response:any)=> {
        console.log(response)
        this.singleCustomerProductPriceList = response.response;

        this.editCustomerProductPriceForm.patchValue(
          {      
            description: response.response.description,
            customerId: response.response.customerId,
            customerName: response.response.customerName,
            productId: response.response.productId,
            productName: response.response.productName,
            uom: response.response.uom,
            minQty: response.response.minQty,
            maxQty: response.response.maxQty,
            perUnitPrice: response.response.perUnitPrice
          }
        );

        this.isEdit = true

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


  getAllProducts(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response)
        this.productList = response.response;
        for(let list of response.response){
          this.products.push(
            {
              name: list.name,
              productId: list.productMasterId
            }
          )
        }
        console.log(this.products)

      }
    )
  }

  getAllCustomerWithoutPagination(){
    this.generic_service.getAllCustomerWithoutPagination().subscribe(
      (response:any)=>{
        console.log(response)
        this.customerList = response.response;
        for(let list of response.response){
          this.customers.push(
            {
              name: list.name,
              customerInfoId: list.customerInfoId
            }
          )
        }
      }
    )
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (response:any)=>{
        console.log(response)
        this.uomList = response.response;
        for(let list of response.response){
          this.uoms.push(
            {
              uomName: list.uomName,
              uomMasterId: list.uomMasterId
            }
          )
        }
      }
    )
  }

  editCustomerProductPrice(){

    const body = {
      "version": 0,
      "isActive": true,
      "description": this.editCustomerProductPriceForm.get('description').value,
      "id": this.singleCustomerProductPriceList.id,
      "customerProductPriceId": this.singleCustomerProductPriceList.customerProductPriceId,
      "customerId": Number(this.editCustomerProductPriceForm.get('customerId').value),
      "customerName": this.editCustomerProductPriceForm.get('customerName').value,
      "productId": Number(this.editCustomerProductPriceForm.get('productId').value),
      "productName": this.editCustomerProductPriceForm.get('productName').value,
      "uom": this.editCustomerProductPriceForm.get('uom').value,
      "minQty": Number(this.editCustomerProductPriceForm.get('minQty').value),
      "maxQty": Number(this.editCustomerProductPriceForm.get('maxQty').value),
      "perUnitPrice": Number(this.editCustomerProductPriceForm.get('perUnitPrice').value),
      "cid": Number(this.cid)
    }
    console.log(body);

    this.generic_service.updateCustomerProductPrice(body).subscribe(
      (response: any)=>{
        console.log(response);
        this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage)
        this.formSubmit = false;
        this.toastr.success(response.message);
        this.editCustomerProductPriceForm.reset();
        this.isEdit = false
      },
      (error: any)=>{
        console.log(error);
        this.toastr.error(error.message);
        this.formSubmit = false;
      }
    )

  }


}

